import { a11yManifest, dialogManifest, formProtectionManifest, tableManifest, validatorsManifest } from "./manifests";

export interface Manifest<Module> {
    shouldAutoload: () => boolean,
    load: () => Promise<Module>,
    onModuleLoaded: (module: Module) => void,
};

type Tool<M> = M extends Manifest<infer T> ? T : never;

const tools = {
    A11y: a11yManifest,
    Dialog: dialogManifest,
    FormProtection: formProtectionManifest,
    Table: tableManifest,
    Validators: validatorsManifest,
};

type Tools = typeof tools;

export type ToolsModules = { [Key in keyof Tools]: Tool<Tools[Key]>; };

export async function loadTool<Name extends keyof ToolsModules>(name: Name): Promise<ToolsModules[Name]> {
    if (USOS.UI[name]) return USOS.UI[name] as ToolsModules[Name];

    const manifest = tools[name];
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!manifest) {
        throw new TypeError('No such tool in toolbox: ' + name);
    }
    const module = await manifest.load() as ToolsModules[Name];
    // @ts-expect-error loaded module type cannot be inferred and thus cannot be properly run via manifest.onModuleLoaded
    manifest.onModuleLoaded(module);
    // @ts-expect-error loaded module type cannot be inferred and thus cannot be installed to USOS.UI namespace
    USOS.UI[name] = module;
    return module;
}

document.addEventListener('DOMContentLoaded', () => {
    for (const key in tools) {
        const manifest = tools[key as keyof Tools];
        if (manifest.shouldAutoload())
            void loadTool(key as keyof Tools);
    }
});
